module.exports = __webpack_public_path__ + "img/shopping-cart-green.9dc462d6.svg";